import VideoElement from './VideoElement';
import VideoElementPresets from './VideoElementPresets';
import VideoElementMetaData from './VideoElementMetaData';
import VideoElementProps from './VideoElementProps';
import { DATA_PANELS } from 'crazyEditor/core/constants/panelConstants';

export default {
  metaData: VideoElementMetaData,
  elementClass: VideoElement.elementClass,
  elementProps: VideoElementProps,
  presets: VideoElementPresets,
  methods: VideoElement.methods,
  panel: DATA_PANELS.VIDEO
};
